var hasSymbol = typeof Symbol === "function";
var rspackQueues = hasSymbol ? Symbol("rspack queues") : "__rspack_queues";
var rspackExports = __webpack_require__.aE = hasSymbol ? Symbol("rspack exports") : "__webpack_exports__";
var rspackError = hasSymbol ? Symbol("rspack error") : "__rspack_error";
var rspackDone = hasSymbol ? Symbol("rspack done") : "__rspack_done";
var rspackDefer = __webpack_require__.zS = hasSymbol ? Symbol("rspack defer") : "__rspack_defer";
__webpack_require__.zT = function(asyncDeps) {
	var hasUnresolvedAsyncSubgraph = asyncDeps.some((id) => {
		var cache = __webpack_module_cache__[id];
		return !cache || cache[rspackDone] === false;
	});
	if (hasUnresolvedAsyncSubgraph) {
		return ({ then(onFulfilled, onRejected) { return Promise.all(asyncDeps.map(__webpack_require__)).then(onFulfilled, onRejected) } });
	}
}
var resolveQueue = function(queue) {
	if (queue && queue.d < 1) {
		queue.d = 1;
    	queue.forEach(function(fn) { fn.r--; });
		queue.forEach(function(fn) { fn.r-- ? fn.r++ : fn(); });
	}
}
var wrapDeps = function(deps) {
	return deps.map(function(dep) {
		if (dep !== null && typeof dep === "object") {
			if(!dep[rspackQueues] && dep[rspackDefer]) {
				var asyncDeps = __webpack_require__.zT(dep[rspackDefer]);
				if (asyncDeps) {
					var d = dep;
					dep = {
						then(onFulfilled, onRejected) {
							asyncDeps.then(function() { return onFulfilled(d); }, onRejected);
						}
					};
				} else return dep;
			}
			if (dep[rspackQueues]) return dep;
			if (dep.then) {
				var queue = [];
				queue.d = 0;
				dep.then(function(r) {
					obj[rspackExports] = r;
					resolveQueue(queue);
				},function(e) {
					obj[rspackError] = e;
					resolveQueue(queue);
				});
				var obj = {};
				obj[rspackDefer] = false;
				obj[rspackQueues] = function(fn) { fn(queue); };
				return obj;
			}
		}
		var ret = {};
		ret[rspackQueues] = function() {};
		ret[rspackExports] = dep;
		return ret;
	});
};
__webpack_require__.a = function(module, body, hasAwait) {
	var queue;
	hasAwait && ((queue = []).d = -1);
	var depQueues = new Set();
	var exports = module.exports;
	var currentDeps;
	var outerResolve;
	var reject;
	var promise = new Promise(function(resolve, rej) {
		reject = rej;
		outerResolve = resolve;
	});
	promise[rspackExports] = exports;
	promise[rspackQueues] = function(fn) { queue && fn(queue), depQueues.forEach(fn), promise["catch"](function() {}); };
	module.exports = promise;
	var handle = function(deps) {
		currentDeps = wrapDeps(deps);
		var fn;
		var getResult = function() {
			return currentDeps.map(function(d) {
				if(d[rspackDefer]) return d;
				if (d[rspackError]) throw d[rspackError];
				return d[rspackExports];
			});
		}
		var promise = new Promise(function(resolve) {
			fn = function() { resolve(getResult); };
			fn.r = 0;
			var fnQueue = function(q) { q !== queue && !depQueues.has(q) && (depQueues.add(q), q && !q.d && (fn.r++, q.push(fn))); };
			currentDeps.map(function(dep) { dep[rspackDefer] || dep[rspackQueues](fnQueue); });
		});
		return fn.r ? promise : getResult();
	};
	var done = function(err) { (err ? reject(promise[rspackError] = err) : outerResolve(exports)), resolveQueue(queue), promise[rspackDone] = true; };
	body(handle, done);
	queue && queue.d < 0 && (queue.d = 0);
};
